import React from 'react';
import { get, has } from 'lodash'

import { withFilterCars } from './../../../shared/containers/containerFilterCars'
import { withAppState } from './../../../shared/containers/containerAppState'

import SearchCarsString from './searchCarsString'
import SortCarsDropdown from './sortCarsDropdown'
import ButtonMediumDefault from './../../../shared/items/contols/buttonMediumDefault'
import ButtonMediumDefaultPrevIcon from './../../../shared/items/contols/buttonMediumDefaultPrevIcon'
import ButtonCounter from './../../../shared/items/static/buttonCounter'
import CarsBookmarkCounter from './carsBookmarkCounter'
import CarsBookmarkCounterWrapper from './carsBookmarkCounterWrapper'
import FilterCarsTooltip from './../../../shared/filterCarsTooltip'
import Icon from './../../../shared/items/static/icon'
import TooltipWrapper from './../../../shared/items/contols/tooltipWrapper'
import ResponsiveWrapper from './../../../shared/responsiveWrapper'

import styles from './carsSortPanel.module.scss'

const CarsSortPanel = props => {
  const { onHandleChangeStore, isCarsSecondSideBarOpen, onOpenCarsSecondSideBar, onCloseCarsSecondSideBar, filterCarsListItems } = props

  return (
    <div className={styles.carsPanel}>

      <SearchCarsString />

      <div className={styles.container_sortFilter}>
        <SortCarsDropdown
          onHandleChangeStore={onHandleChangeStore}
          filterItems={filterCarsListItems}
        />
        <div className={styles.container_filter}>

          <ResponsiveWrapper device="desktop">
            <TooltipWrapper title={`${get(filterCarsListItems, ["isBookmark"], false) ? "Показать все" : "Показать Избранные"}`} position="top">
              <div>
                <ButtonMediumDefault
                  className={get(filterCarsListItems, ["isBookmark"], false) ? 'active' : ''}
                  handleClick={onHandleChangeStore.bind(this, 'isBookmark', !get(filterCarsListItems, ["isBookmark"], false))}
                >
                  <ButtonMediumDefaultPrevIcon>
                    <Icon name="fav" />
                  </ButtonMediumDefaultPrevIcon>
                  <CarsBookmarkCounter />
                </ButtonMediumDefault>
              </div>
            </TooltipWrapper>
          </ResponsiveWrapper>

          <ResponsiveWrapper device="desktop" invert={true}>
            <TooltipWrapper title={`${get(filterCarsListItems, ["isBookmark"], false) ? "Показать все" : "Показать Избранные"}`} position="top">
              <div>
                <ButtonMediumDefault
                  className={get(filterCarsListItems, ["isBookmark"], false) ? 'active' : ''}
                  handleClick={onHandleChangeStore.bind(this, 'isBookmark', !get(filterCarsListItems, ["isBookmark"], false))}
                >
                  <ButtonMediumDefaultPrevIcon>
                    <Icon name="fav" />
                  </ButtonMediumDefaultPrevIcon>
                  <CarsBookmarkCounterWrapper>
                    <CarsBookmarkCounter />
                  </CarsBookmarkCounterWrapper>
                </ButtonMediumDefault>
              </div>
            </TooltipWrapper>
          </ResponsiveWrapper>

          <ResponsiveWrapper device="desktop">
            <FilterCarsTooltip>
              <ButtonMediumDefault
                className={isCarsSecondSideBarOpen ? 'active' : ''}
                handleClick={isCarsSecondSideBarOpen ? onCloseCarsSecondSideBar : onOpenCarsSecondSideBar}
              >
                <ButtonMediumDefaultPrevIcon>
                  <Icon name="filter" />
                </ButtonMediumDefaultPrevIcon>
                {get(filterCarsListItems, ["filterCount"], 0) > 0 ? <ButtonCounter count={get(filterCarsListItems, ["filterCount"], 0)} /> : null}
              </ButtonMediumDefault>
            </FilterCarsTooltip>
          </ResponsiveWrapper>

          <ResponsiveWrapper device="desktop" invert={true}>
            <FilterCarsTooltip>
              <ButtonMediumDefault
                className={isCarsSecondSideBarOpen ? 'active' : ''}
                handleClick={isCarsSecondSideBarOpen ? onCloseCarsSecondSideBar : onOpenCarsSecondSideBar}
              >
                <ButtonMediumDefaultPrevIcon>
                  <Icon name="filter" />
                </ButtonMediumDefaultPrevIcon>
                {
                  get(filterCarsListItems, ["filterCount"], 0) > 0
                    ? <CarsBookmarkCounterWrapper>
                      <ButtonCounter count={get(filterCarsListItems, ["filterCount"], 0)} />
                    </CarsBookmarkCounterWrapper>
                    : null
                }
              </ButtonMediumDefault>
            </FilterCarsTooltip>
          </ResponsiveWrapper>
        </div>
      </div>
    </div >
  )
}

export default withAppState(withFilterCars(React.memo(CarsSortPanel)))
